// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3sZO-","productName":"Table_productName__1q0Za"};